export * from './extracao-slice'